import { createClient } from '@supabase/supabase-js'

export default defineNuxtPlugin(nuxtApp => {

  const config = useRuntimeConfig().public
  
  const supabase = createClient(
    config.SUPABASE_URL as string, 
    config.SUPABASE_PUBLIC_KEY as string, 
    {
      realtime: {
        worker: true
      }
    }
  )

  nuxtApp.vueApp.provide('supabase', supabase)
  nuxtApp.provide('supabase', supabase)


})
